import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface RequestEventArgs<T> {
  preventDefault?: Function;
  response: T;
}

class RequestEvent<T> extends EventData<Requestable<T>> {

  preventDefault?: Function;
  response: T;

  constructor({ preventDefault, response }: RequestEventArgs<T>) {
    super();
    this.preventDefault = preventDefault;
    this.response = response;
  }
}

class RequestEventListener<T> extends EventListener<Requestable<T>, RequestEvent<T>, RequestEventArgs<T>> {
  constructor() {
    super(RequestEvent);
  }
}

export default interface Requestable<T> extends Mountable {

  /** @event */
  onCatch: RequestEventListener<Error | Record<string, unknown>>;
  
  /** @event */
  onSuccess: RequestEventListener<T>;
}

export { RequestEventListener, RequestEvent };
